import { render } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import HeaderComponent from 'react-components/Header';
import BundleBuilderHeader from 'react-components/BundleBuilderHeader';

export async function Root(element, data) {
    let { customer, templateSuffix, redirectCartToIndex, menuItems, announcements } = data;

    let { announcement_message } =  announcements || {};

    function Header() {
      const [visible, setVisible] = useState(true);
      const isBundleBuilder = templateSuffix === 'bundle-builder';

      useEffect(() => {
        let lastPos = window.scrollY;
        let ticking = false;

        const handleScroll = () => {
          if (templateSuffix === 'bundle-builder' && window.location.hash) return;
        
          const currentPos = window.scrollY;
        
          if (!ticking) {
            window.requestAnimationFrame(() => {
              setVisible(currentPos < 600 || currentPos < lastPos);
              lastPos = currentPos;
              ticking = false;
            });
            ticking = true;
          }
        };
        

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
      }, []);

    return (
      <div class="tailwind-scope">
        <div className={`tw-fixed tw-inset-x-0 tw-top-0 tw-z-[1001] tw-h-[60px] tw-bg-white tw-shadow-[0px_6px_15px_-2px_rgba(16,24,40,0.08)] desktop:tw-h-[124px]
          ${isBundleBuilder && !visible ? 'tw-translate-y-[-100px] tablet:tw-translate-y-[-124px]' : 'tw-translate-y-0'} tw-transition-transform tw-duration-300 tw-ease-in-out`} role="banner" aria-hidden={!visible}> 
          <div class="tw-mx-auto tw-h-[60px] tw-items-center desktop:tw-h-[124px]" aria-live="polite">
            <HeaderComponent customer={customer} visible={visible} isBundleBuilder={isBundleBuilder} redirectCartToIndex={redirectCartToIndex} menuItems={menuItems} announcementMessages={announcement_message} />
            {isBundleBuilder && <BundleBuilderHeader visible={visible} />}
          </div>
        </div>
      </div>
    );
  }
    render(<Header />, element);
}